// extracted by mini-css-extract-plugin
module.exports = {"JobBoardContainer":"JobBoardContainer_JobBoardContainer__UnYVF","FiltersLegendWrapper":"JobBoardContainer_FiltersLegendWrapper__35byE"};